import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';

/**
 * Rich Markdown renderer for user-generated content (comments, AI chat messages).
 * Supports GFM (tables, strikethrough, task lists) and math (LaTeX via KaTeX).
 *
 * NOTE: This is separate from article rendering which uses additional plugins
 * like remarkBreaks and rehypeBlockIndexer for article-specific features.
 */
export default function RichMarkdown({ children }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkMath]}
      rehypePlugins={[[rehypeKatex, { strict: false }]]}
    >
      {children}
    </ReactMarkdown>
  );
}

